<template>
  <div class="header-popup">
    <img
      v-if="onCloseClick"
      src="/static/close-popup.svg"
      alt="Close"
      class="close-icon"
      @click="onCloseClick"
    />
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "HeaderPopup",
  components: {},
  props: {
    onCloseClick: Function,
    toggleButtonRef: HTMLElement,
  },
  data() {
    return {
      isOpen: false,
    };
  },
  computed: {},
  methods: {
    close(e) {
      // do not close on toggle button click because toggle button closes popup itself
      if (this.toggleButtonRef && this.toggleButtonRef.contains(e.target)) {
        return false;
      }
      if (
        e.target !== this.toggleButtonRef &&
        e.target !== this.$el &&
        !this.$el.contains(e.target) &&
        typeof this.onCloseClick === "function"
      ) {
        this.onCloseClick();
      }
    },
  },
  mounted() {
    setTimeout(() => {
      window.addEventListener("mousedown", this.close);
      window.addEventListener("touchstart", this.close);
    }, 0);
  },

  beforeDestroy() {
    window.removeEventListener("mousedown", this.close);
    window.removeEventListener("touchstart", this.close);
  },
};
</script>

<style scoped>
.header-popup {
  position: relative;
  background-color: #f9f9f9;
  border-radius: 8px;
  padding: 16px 8px 0;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  width: auto;
  height: auto;
  box-sizing: border-box;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.5;
  color: #4a4a4a;
  white-space: normal;
  max-height: calc(100vh - 100px);
  overflow: auto;
}
.close-icon {
  position: absolute;
  top: 16px;
  right: 16px;
  cursor: pointer;
  z-index: 1;
}
.close-icon:hover {
  opacity: 0.5;
  transition: opacity 0.5s;
}

@media (max-width: 600px) {
  .header-popup {
    max-width: 100%;
    overflow-x: scroll;
  }
}
</style>
